import { Module, ModuleUpdateV2Input, VcsProvider } from "types/generated";

import { type ModuleSettingsSourceCodeFormFields } from "./EditForm";

export const getDefaultValues = (module: Module) => {
  const isSpacelift = module.provider === VcsProvider.Spacelift;

  return {
    projectRoot: module.projectRoot || "",
    branch: module.branch,
    repositoryURL: module.repositoryURL?.trim() || undefined,
    namespace: isSpacelift ? module.repository : module.namespace,
    repository: module.repository,
    provider: module.provider,
    vcsIntegrationId: module.vcsIntegration?.id,
    gitSparseCheckoutPaths: module.gitSparseCheckoutPaths?.length
      ? module.gitSparseCheckoutPaths.map((value) => ({ value }))
      : [{ value: "" }],
  };
};

export const mapModuleSourceCodeUpdateInput = (
  formData: ModuleSettingsSourceCodeFormFields
): Partial<ModuleUpdateV2Input> => {
  const isSpacelift = formData.provider === VcsProvider.Spacelift;

  return {
    ...formData,
    projectRoot: formData.projectRoot || null,
    repositoryURL: formData.repositoryURL?.trim() || null,
    gitSparseCheckoutPaths: formData.gitSparseCheckoutPaths
      .map(({ value }) => value.trim())
      .filter((value) => value),
    ...(isSpacelift
      ? {
          branch: "main",
          repository: formData.namespace,
          namespace: null,
          vcsIntegrationId: formData.namespace,
        }
      : {}),
  };
};
